import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from './StateProvider.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import axios from 'axios';
import configData from './Config';

import { getPermission } from './Utils/permissions.js';
import Select from './Components/select.js';
import Title from './Title.js';
import ReactToPrint from 'react-to-print';
import { assetTypes } from './Utils/asset.js';

const connectionTypes = [
    { id: 'pipe', name: 'Pipe' },
    { id: 'duct', name: 'Duct' },
    { id: 'wire', name: 'Wire' },
    { id: 'cable', name: 'Cable' },
    { id: 'hose', name: 'Hose' },
    { id: 'tube', name: 'Tube' },
    { id: 'conduit', name: 'Conduit' },
    { id: 'trunk', name: 'Trunk Line' }
];

function Connections({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    const [filteredconnections, setFilteredconnections] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const filtered = project.connections.filter((connection) =>
            connection.id
        );
        setFilteredconnections(filtered)
    }, [project, search]);

    const closeButton = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const addButton = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AddConnection />, modaltype: 'large', modaltitle: 'Add Connection' }));
    }

    const editButton = (connection) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditConnection connection={connection} mode='edit' />, modaltype: 'large', modaltitle: 'Edit Connection' }));
    }

    const removeButton = (connection) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <RemoveConnection connection={connection} />, modaltype: 'small', modaltitle: 'Remove Connection' }));
    }

    const viewButton = (connection) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewConnection connection={connection} />, modaltype: 'large', modaltitle: 'View Connection' }));
    }

    function NewRow({ row, index, data, setData }) {
        const handleTypeChange = (newType) => {
            const updated = [...data];
            updated[index].type = newType;
            setData(updated);
        };

        const handleNameChange = (newName) => {
            const updated = [...data];
            updated[index].name = newName;
            setData(updated);
        }

        const handleFromAsset = (fromassetid) => {
            const updated = [...data];
            updated[index].fromassetid = fromassetid;
            setData(updated);
        }

        const handleToAsset = (toassetid) => {
            const updated = [...data];
            updated[index].toassetid = toassetid;
            setData(updated);
        }

        const handleRemoveRow = () => {
            const updated = [...data];
            updated.splice(index, 1);
            setData(updated);
        };

        return (
            <tr>
                <td>
                    <Select
                        data={connectionTypes}
                        itemid={row.type}
                        setItemid={(accountId) => handleTypeChange(accountId)}
                    />
                </td>
                <td>
                    <input
                        className='modal_input'
                        type="text"
                        placeholder=''
                        value={row.name}
                        onChange={(e) => handleNameChange(e.target.value)}
                    />
                </td>
                <td>
                    <Select
                        data={project.assets}
                        itemid={row.fromassetid}
                        setItemid={(fromasset) => handleFromAsset(fromasset)}
                    />
                </td>
                <td>
                    <Select
                        data={project.assets}
                        itemid={row.toassetid}
                        setItemid={(toasset) => handleToAsset(toasset)}
                    />
                </td>
                <td>
                    <div className='modal_removeitembutton' onClick={handleRemoveRow}>&minus;</div>
                </td>
            </tr>
        );
    }

    const handleAddRow = (rows, setRows) => {
        setRows([...rows, { type: '', name: '', fromassetid: '', toassetid: '' }])
    }

    function AddConnection() {
        const [rows, setRows] = useState([{ type: '', name: '', fromassetid: '', toassetid: '' }]);
        const [name, setName] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        const addConnection = (name, rows, setResult) => {

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Assets',
                'add',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            if (!name) {
                setResult('Missing info')
                return
            }

            setLoading(true);

            const trimmedname = name.trim();

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                name: trimmedname,
                rows: rows
            }

            axios.post(configData.CONTROLLERURL + configData.ADDCONNECTION, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        data.id = res.data.id;
                        dispatch({
                            type: 'ADD_CONNECTION',
                            connection: data
                        });
                        closeButton();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Name</th><th>From</th><th>To</th><th></th></tr></thead>
                                <tbody>
                                    {
                                        rows.map((row, index) => (
                                            <NewRow
                                                key={'row' + index}
                                                row={row}
                                                index={index}
                                                data={rows}
                                                setData={setRows}
                                            />
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={() => handleAddRow(rows, setRows)}>Add row</button>
                        </div>
                        <div className='modal_buttoncontainer'></div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => addConnection(name, rows, setResult)} disabled={loading}>{loading ? 'Loading...' : 'Save'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={closeButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function EditConnection({ connection }) {
        const [id, setId] = useState('');

        const [name, setName] = useState('');
        const [rows, setRows] = useState([{ type: '', name: '', fromassetid: '', toassetid: '' }]);

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            setId(connection.id);
            setName(connection.name);
            setRows(connection.rows);
        }, [connection]);

        const updateConnection = () => {

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Assets',
                'update',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            if (!name) {
                setResult('Missing info')
                return
            }

            setLoading(true);

            const trimmedname = name.trim();

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
                name: trimmedname,
                rows: rows
            }

            axios.post(configData.CONTROLLERURL + configData.UPDATECONNECTION, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'UPDATE_CONNECTION',
                            connection: data
                        });
                        closeButton();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Name</th><th>From</th><th>To</th><th></th></tr></thead>
                                <tbody>
                                    {
                                        rows.map((row, index) => (
                                            <NewRow
                                                key={'row' + index}
                                                row={row}
                                                index={index}
                                                data={rows}
                                                setData={setRows}
                                            />
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={() => handleAddRow(rows, setRows)}>Add row</button>
                        </div>
                        <div className='modal_buttoncontainer'></div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => updateConnection()} disabled={loading}>{loading ? 'Loading...' : 'Update'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => removeButton(connection)}>Remove</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={closeButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function RemoveConnection({ connection }) {
        const [id, setId] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            setId(connection.id)
        }, [connection]);

        const removeConnection = (id) => {
            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Assets',
                'remove',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id
            }

            axios.post(configData.CONTROLLERURL + configData.REMOVECONNECTION, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'REMOVE_CONNECTION',
                            id: id
                        });
                        closeButton();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => removeConnection(id)} disabled={loading}>{loading ? 'Loading...' : 'Remove'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={closeButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function ViewConnection({ connection }) {
        const printRef = useRef();

        const [id, setId] = useState('');
        const [name, setName] = useState('');
        const [rows, setRows] = useState([]);

        useEffect(() => {
            setId(connection.id);
            setName(connection.name);
            setRows(connection.rows);
        }, [connection]);

        return (
            <div className='modal_body'>
                <div className='modal_printable' ref={printRef}>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Project Name</div>
                        </div>
                        <div className='modal_rowsection'>{project.name}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>ID</div>
                        </div>
                        <div className='modal_rowsection'>{id}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>{name}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Name</th><th>From</th><th>To</th></tr></thead>
                                <tbody>
                                    {
                                        rows.map((row, index) => {
                                            let typeName = connectionTypes.find(connection => connection.id == row.type)?.name
                                            let fromAsset = project.assets.find(asset => asset.id == row.fromassetid)?.name
                                            let toAsset = project.assets.find(asset => asset.id == row.toassetid)?.name
                                            return (
                                                <tr key={'row' + index}>
                                                    <td><div>{typeName}</div></td>
                                                    <td><div>{row.name}</div></td>
                                                    <td><div>{fromAsset}</div></td>
                                                    <td><div>{toAsset}</div></td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<button className="modal_button">Print</button>)}
                                content={() => printRef.current}
                            />
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={closeButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='connections'>
            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={addButton}>Add Connection</button>
                </div>
                <div className='buttonsection'>
                    <input
                        className='input'
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            <table className='table'>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th>ID</th>
                        <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        filteredconnections.map((connection, index) => {

                            return (
                                <tr key={'connection' + index}>
                                    <td><div className='table_button' onClick={() => editButton(connection)}>Edit</div></td>
                                    <td><div className='table_button' onClick={() => viewButton(connection)}>View</div></td>
                                    <td><div>{connection.id}</div></td>
                                    <td><div>{connection.name}</div></td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        </div>
    );
}

export default Connections;